import * as S from '@/components/Filters/InlineFilters/InlineFilters.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export function InlineFiltersSkeletonLoader() {
  return (
    <S.Wrapper>
      <S.FiltersContainer>
        <SkeletonLoader width={100} height={35} borderRadius={100} />
        <SkeletonLoader width={100} height={35} borderRadius={100} />
      </S.FiltersContainer>
      <S.SortContainer>
        <SkeletonLoader width={75} height={17} borderRadius={7} />
      </S.SortContainer>
    </S.Wrapper>
  );
}
